import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'Vídeos Institucionais',
    desc: 'Conteúdo audiovisual que apresenta sua marca com credibilidade e profissionalismo.',
    items: [
      'Vídeos institucionais e comerciais',
      'Roteirização e direção de conteúdo',
      'Captação em locação ou estúdio',
      'Narração e trilha sonora',
    ],
  },
  {
    title: 'Conteúdo para Redes',
    desc: 'Vídeos pensados para o formato e o ritmo de cada rede social.',
    items: [
      'Reels, Stories e conteúdo vertical',
      'Sessões fotográficas de produto e marca',
      'Cobertura de eventos e bastidores',
      'Adaptação de formatos para cada plataforma',
    ],
  },
  {
    title: 'Edição & Pós-Produção',
    desc: 'A etapa que transforma captação bruta em peça pronta pra converter.',
    items: ['Edição e montagem', 'Correção de cor', 'Legendagem e acessibilidade', 'Exportação otimizada por canal'],
  },
]

const STEPS = [
  { title: 'Briefing', desc: 'Entendemos o objetivo do vídeo, o público e a mensagem central.' },
  { title: 'Roteiro', desc: 'Estruturamos roteiro e planejamento de captação.' },
  { title: 'Captação', desc: 'Gravamos com equipamento e direção profissional.' },
  { title: 'Entrega', desc: 'Editamos, ajustamos e entregamos nos formatos certos para cada canal.' },
]

function ServiceAudiovisual() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - Produção Audiovisual'
      eyebrow='Produção Audiovisual'
      title='Conteúdo visual que impacta e permanece na memória'
      subtitle='Oferecemos produção audiovisual de alta qualidade, transformando ideias em projetos marcantes para todos os canais da sua marca.'
      intro='Um bom vídeo não é só sobre imagem bonita, é sobre atenção, emoção e conversão. Cada projeto de produção audiovisual da Dorac parte do comportamento do seu público: o que prende a atenção nos primeiros segundos, o que gera identificação e o que faz a pessoa avançar até a ação.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero produção audiovisual'
    />
  )
}

export default ServiceAudiovisual
